/**
 * "Tell the Build Team" — the one place the feedback channel is configured.
 * Replaces the five scattered `mailto:` links (Beta-1 plan P1-26). Notes are written to
 * Hugo_Feedback and relayed to the build team by n8n (P7-10); the mailto stays as a fallback.
 */
export const FEEDBACK_EMAIL = 'alex.samaniego@ppiweb.com';
export const OPEN_FEEDBACK_EVENT = 'repsit-open-feedback';

export const FEEDBACK_TYPES = [
  { value: 'feedback', label: 'Feedback or idea', subject: 'REPSit.ai beta feedback' },
  { value: 'bug', label: 'Something is broken', subject: 'REPSit.ai beta — bug' },
  { value: 'confusing', label: 'Something is confusing', subject: 'REPSit.ai beta — confusing screen' },
  { value: 'question', label: 'I have a question', subject: 'REPSit.ai beta — question' },
  { value: 'sandbox_reset', label: 'Reset my sandbox (Magnum, Inc.)', subject: 'REPSit.ai sandbox reset request' },
  { value: 'api_interest', label: 'API / integrations interest', subject: 'REPSit.ai API interest' },
];

export const feedbackType = (value) =>
  FEEDBACK_TYPES.find((t) => t.value === value) || FEEDBACK_TYPES[0];

/** Open the Tell-the-Build-Team dialog from anywhere (no context plumbing needed). */
export function openFeedback(type = 'feedback', extra = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_FEEDBACK_EVENT, { detail: { type, ...extra } }));
}

/** Email fallback (used inside the dialog and if the write fails). */
export function feedbackMailto(type = 'feedback', body = '') {
  const t = feedbackType(type);
  const params = new URLSearchParams({ subject: t.subject });
  if (body) params.set('body', body);
  return `mailto:${FEEDBACK_EMAIL}?${params.toString().replace(/\+/g, '%20')}`;
}
